import { all } from 'redux-saga/effects';

import autenticacao from './autenticacao/sagas';
import pedido from './pedido/sagas';
import notificacao from './notificacao/sagas';

export default function* rootSaga() {
  return yield all([autenticacao, pedido, notificacao]);
}
